import { render, staticRenderFns } from "./VerticalNavMenuLink.vue?vue&type=template&id=eb0cb7ca&scoped=true"
import script from "./VerticalNavMenuLink.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb0cb7ca",
  null
  
)

export default component.exports